import Vue from 'vue';

export const pageRequests = Vue.observable({ current: { pending: 0, failed: false } });
export function resetPageRequests() {
  pageRequests.current = { pending: 0, failed: false };
}
export function trackPageRead(fetch) {
  // Capture the page generation: old responses cannot change a newly opened page's status.
  const page = pageRequests.current;
  page.pending += 1;
  return Promise.resolve().then(fetch).catch(error => {
    page.failed = true;
    throw error;
  }).finally(() => { page.pending -= 1; });
}
